import { Button, Flex, Modal, Text } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useParams } from 'react-router-dom';

import { useLocalStore } from '@/hooks/useLocalStore';
import { DocumentActionsStore } from '@/stores/local/shared/DocumentActionsStore';
import { useSidebarDocumentsStore } from '@/stores/local/sidebar/SidebarDocumentsStore';

import s from './DeleteDocumentPopup.module.scss';

const DeleteDocumentPopup: React.FC = () => {
  const {
    popups: { deleteDocumentPopup },
    treeStore,
  } = useSidebarDocumentsStore();
  const { id } = useParams();

  const documentActions = useLocalStore(
    () =>
      new DocumentActionsStore({
        documentId: deleteDocumentPopup.entity,
        organizationId: id,
        treeStore,
      }),
  );

  const handleDelete = React.useCallback(async () => {
    documentActions.setDocumentId(deleteDocumentPopup.entity);

    await documentActions.deleteDocument();

    if (documentActions.deleteMeta.isLoaded) {
      deleteDocumentPopup.close();
    }
  }, [deleteDocumentPopup, documentActions]);

  return (
    <Modal
      centered
      title={<Text fw="400">Удалить документ</Text>}
      opened={deleteDocumentPopup.isOpen}
      onClose={deleteDocumentPopup.close}
    >
      <Flex direction="column" align="center" justify="center" gap="lg">
        <Text c="gray">Вы действительно хотите удалить документ?</Text>
        <Flex className={s.root__footer} justify="flex-end">
          <Button variant="transparent" onClick={deleteDocumentPopup.close} size="sm">
            <Text fw="400" c="dark">
              Отменить
            </Text>
          </Button>
          <Button
            loading={documentActions.deleteMeta.isLoading}
            variant="filled"
            color="red"
            onClick={handleDelete}
            size="sm"
          >
            <Text fw="400">Удалить</Text>
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default observer(DeleteDocumentPopup);
